module.exports = __webpack_public_path__ + "static/media/sider-logo.872ee784.svg";